import { isBlank, isEmptyObject } from 'components/Common/Utils/StringUtils';
import * as Constants from 'constants/Constants';

const field = [
    { name: 'vendor_name', value: 'Vendor' },
    { name: 'integration_type', value: 'Integration Type' },
    { name: 'account_code', value: 'Account Code' },
    { name: 'customer_code', value: 'Customer Code' },
    { name: 'user_name', value: 'User Name' },
    { name: 'password', value: 'Password' },
    { name: 'connection_type', value: 'Connection Type' },
    { name: 'url', value: 'URL' },
    { name: 'remote_folder', value: 'Remote Folder' },
    { name: 'file_mask', value: 'File Mask' },
    { name: 'port', value: 'Port' },
    { name: 'security_card_number', value: 'Security Card Number' },
    { name: 'interactive_user_name', value: 'User Name' },
    { name: 'interactive_password', value: 'Password' }
];

const validateFuelFields = (event) => {
    const name = event.target.name;
    const value = event.target.value ? event.target.value : '';
    let fieldName = '';
    field.forEach((selectedField) => {
        if (selectedField.name === name) {
            fieldName = selectedField.value;
        }
    });
    if (value.length < 1) {
        return {
            invalid: true,
            message: fieldName + Constants.IS_REQUIRED
        };
    } else if (name === 'account_code') {
        let resObj;
        let invalid = false;
        let message = '';
        const pattern = '^[0-9a-zA-Z]*$';
        if (value.length < 1) {
            invalid = true;
            message = 'Account Code' + Constants.IS_REQUIRED;
        } else if (value.match(pattern) === null) {
            invalid = true;
            message = 'Account Code' + Constants.IS_INVALID;
        }
        resObj = {
            invalid: invalid,
            message: message
        };
        return resObj;
    } else if (name === 'customer_code') {
        let resObj;
        let invalid = false;
        let message = '';
        const pattern = '^[0-9a-zA-Z]*$';
        if (value.length < 1) {
            invalid = true;
            message = 'Customer Code' + Constants.IS_REQUIRED;
        } else if (value.match(pattern) === null) {
            invalid = true;
            message = 'Customer Code' + Constants.IS_INVALID;
        }
        resObj = {
            invalid: invalid,
            message: message
        };
        return resObj;
    } else {
        return {
            invalid: false,
            message: ''
        };
    }
};

export const checkEmptyFields = (fuelObject, displayType, field) => {
    let defaultPropertiesEmpty = true;
    let batchPropertiesEmpty = true;
    let interactivePropertiesEmpty = true;
    let finalresult;

    defaultPropertiesEmpty =
        Object.values(field).some((row) => {
            return row.invalid;
        }) || isBlank(fuelObject.vendor_name);

    if (!isEmptyObject(fuelObject.batch)) {
        batchPropertiesEmpty = Object.values(fuelObject.batch).some((x) => {
            return x === null || x === '';
        });
    }
    if (!isEmptyObject(fuelObject.interactive)) {
        interactivePropertiesEmpty = Object.values(fuelObject.interactive).some((x) => {
            return x === null || x === '';
        });
    }
    if (displayType.comDataInteractive) {
        finalresult =
            defaultPropertiesEmpty ||
            interactivePropertiesEmpty ||
            isBlank(fuelObject.integration_type);
    } else if (displayType.batchType) {
        finalresult = defaultPropertiesEmpty || batchPropertiesEmpty;
    } else if (displayType.interactive) {
        finalresult = defaultPropertiesEmpty;
    }

    return finalresult;
};

export default validateFuelFields;
